import { useQuery } from '@tanstack/react-query';
import { fetchSubjectCategories } from '../services/subjectCategoryService';

export function useSubjectCategories(params = {}, options = {}) {
  return useQuery({
    queryKey: ['subjectCategories', params],
    queryFn: async () => {
      const { payload } = await fetchSubjectCategories(params);
      const subjectCategoryList = Array.isArray(payload?.subject_category_list)
        ? payload.subject_category_list
        : [];

      return {
        allSubjectCount: Number(payload?.all_subject_count || 0),
        subjectCategoryList,
      };
    },
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    retry: 2,
    refetchOnMount: 'always',
    refetchOnWindowFocus: false,
    refetchOnReconnect: true,
    placeholderData: (previousData) =>
      previousData ?? {
        allSubjectCount: 0,
        subjectCategoryList: [],
      },
    ...options,
  });
}
